import * as React from 'react';
import Icon from 'components/Icon';

const VideoPlaceholder: React.FC = () => {
  return (
    <div className="ex3d-video flex size-full items-center justify-center">
      <Icon className="ex3d-icon--avatar h-20 w-[8.75rem] bg-white" />
    </div>
  );
};

export default VideoPlaceholder;
